const AI_PDF_CONST = {
  API_ENDPOINT: {
    LOGIN: "/users/login",
    DOCS: "/docs/",
    GPT_QUERY: "/gpt/query",
    GPT_HISTORY: "/gpt/qa_history",
    GET_SIGNED_URL: "/docs/get_signed_url",
  },

  ROUTE: {
    ROOT: "/",
    HOME: "/home",
    DASHBOARD: "/dashboard",
    LOGIN: "/login",
    DOCUMENT_VIEW: "/documents/:id",
    DOCUMENTS: "/documents",
    HOLIOS: "/holios",
    HOLIOS_UPLOAD_DATA: "/holios_upload_data",
    AI_AUTOMATION: "/ai-automation",
    ADMIN_ORGS: "/admin/orgs",
    ADMIN_ORG_USERS: "/admin/orgs/:org_id/users",
    ADMIN_DASHBOARD: "/dashboard",
    ADMIN_TENANTS: "/admin/tenants",
    ADMIN_TENANTS_CREATE: "/admin/tenants/create",
    ADMIN_TENANT_DETAIL: "/admin/tenants/:tenant_id",
    ADMIN_TENANT_ONBOARDING: "/admin/tenants/:tenant_id/onboarding",
    ADMIN_TENANT_PROFILES: "/admin/tenant-profiles",
    HOME2: "/home2",
    AI: "/ai",
    AI_A: "/ai-a",
    AI_B: "/ai-b",
    AI_AUTOMATION_2: "/ai-automation2",
    COMMUNICATION: "/communication",
    AI_COMM: "/ai-comm",
    PDF_TO_EXL: "/pdf-to-exl",
    MY_DOCS: "/my-docs",
    VOICE_CALL: "/voice-call",
    ADMIN_TEAM: "/admin/team",
    ADMIN_SERVICES: "/admin/services",
    ADMIN_CONFIGS: "/admin/configs",
    ADMIN_AUDIT_LOGS: "/admin/audit-logs",
    ADMIN_ONBOARDING: "/admin/onboarding",
    ADMIN_WHATSAPP_INBOX: "/admin/whatsapp-inbox",
    PUBLIC_TENANT_PROFILE: "/public/tenants/:tenantId",
    PUBLIC_TENANT_DIRECTORY: "/public/tenants",
  },
};

export default AI_PDF_CONST;
